function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 49.49,
  fill: "#24d5a6",
  opacity: 0.5,
  "data-name": "FINAL back"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "FINAL front"
}, /*#__PURE__*/React.createElement("rect", {
  x: 5.61,
  y: 9.55,
  width: 57.49,
  height: 39.93,
  rx: 5.32,
  ry: 5.32,
  fill: "#353e58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4 9.55a4.79 4.79 0 00-4.79 4.79v30.34a4.79 4.79 0 004.79 4.79h9.51L44.75 9.55z",
  fill: "#252e44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 31.83h-7.4a2.28 2.28 0 01-2.13-2.4v-3.27a2.28 2.28 0 012.13-2.4H19a2.28 2.28 0 012.13 2.4v3.27a2.28 2.28 0 01-2.13 2.4z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.9,
  y: 45.88,
  width: 57.49,
  height: 39.93,
  rx: 5.32,
  ry: 5.32,
  fill: "#088af4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.69 45.88a4.79 4.79 0 00-4.79 4.79V81a4.79 4.79 0 004.79 4.79h9.51L77 45.88z",
  fill: "#0f85ba"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.24 68.16h-7.36a2.28 2.28 0 01-2.13-2.4v-3.27a2.28 2.28 0 012.13-2.4h7.36a2.28 2.28 0 012.13 2.4v3.27a2.28 2.28 0 01-2.13 2.4z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#088af4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 62h3.81v17.37a.46.46 0 00.46.46H22a.46.46 0 00.46-.46V62h3.81a.75.75 0 00.63-1.16l-4.9-7.6a.75.75 0 00-1.25 0l-5.35 7.55A.75.75 0 0016 62z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 22.22,
  y: 77.38,
  width: 2.04,
  height: 2.84,
  rx: 0.21,
  ry: 0.21,
  transform: "rotate(-90 23.245 78.805)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 26.88,
  y: 77.38,
  width: 2.04,
  height: 2.84,
  rx: 0.21,
  ry: 0.21,
  transform: "rotate(-90 27.895 78.805)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 31.61,
  y: 77.38,
  width: 2.04,
  height: 2.84,
  rx: 0.21,
  ry: 0.21,
  transform: "rotate(-90 32.635 78.805)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#353e58"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.66 34.9h-3.81V17.52a.46.46 0 00-.46-.46h-1.71a.46.46 0 00-.46.46V34.9h-3.81a.75.75 0 00-.63 1.16l4.86 7.58a.75.75 0 001.25 0l5.39-7.58a.75.75 0 00-.62-1.16z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 75.41,
  y: 16.66,
  width: 2.04,
  height: 2.84,
  rx: 0.21,
  ry: 0.21,
  transform: "rotate(90 76.44 18.08)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 70.76,
  y: 16.66,
  width: 2.04,
  height: 2.84,
  rx: 0.21,
  ry: 0.21,
  transform: "rotate(90 71.78 18.08)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 66.02,
  y: 16.66,
  width: 2.04,
  height: 2.84,
  rx: 0.21,
  ry: 0.21,
  transform: "rotate(90 67.04 18.08)"
})));

function SvgIconBalanceTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgIconBalanceTransfer as ReactComponent };